import { Injectable } from '@angular/core';
import { UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { OrganizationService } from '../services/organization.service';
import { SignalRService } from '../services/signalr.service';
import { NavigationService } from '../services/navigation.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationGuard {
  constructor(
    private authService: AuthService,
    private organizationService: OrganizationService,
    private signalRService: SignalRService,
    private navigationService: NavigationService,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    await this.authService.initializeUser();
    if (!this.authService.isLoggedIn) {
      await this.navigationService.navigateToLogin('AuthenticationGuard - user not logged in', false, false);
      return false;
    }
    await this.organizationService.initializeOrganizationsIfNeeded();
    await this.signalRService.startConnection();
    return true;
  }

  async canDeactivate(): Promise<boolean | UrlTree> {
    await this.signalRService.stopConnection();
    return true;
  }
}
